(function () {
  'use strict';

  var CONFIG = {
    storageKey: 'ayamveda_vitality_mix_utm_angle',
    storageTimeKey: 'ayamveda_vitality_mix_utm_angle_time',
    expiryDays: 30,

    acceptedParams: [
      'utm_campaign',
      'utm_content',
      'utm_term',
      'angle',
      'offer',
      'campaign'
    ]
  };

  var CONTENT = {
    default: {
      hero_h1: "Your protein is<br><span>doing half the job.</span>",
      hero_subhead:
        "Vitality Mix adds 8 clinically-dosed Ayurvedic extracts - testosterone, stamina, strength & recovery - directly into your protein intake. One 4g sachet. Five seconds.",
      hero_badge: "New Formula · Extract-Based",
       hero_pour:"Into protein shake/milk/water",
      hero_cta: "Add to Cart — Start My Protocol",
      works_heading: "Works best with your routine.",
        works_subheading: "Add it to what you already do.",
        works_box_heading: "💡 Mix it in. Level it up.",
        works_note: "<p><strong>Pro tip:</strong> Men who pair Vitality Mix with even 3 workouts/week report results 2× faster. The herbs prime your hormonal environment — exercise activates it.</p>",
        works_item_icon_1: "🏋️",
        works_item_title_1: "Exercise",
        works_item_desc_1: "Amplifies workout recovery and stamina gains",

        works_item_icon_2: "🥤",
        works_item_title_2: "Protein Shake",
        works_item_desc_2: "Add one sachet to your daily protein for a powerful combo",

        works_item_icon_3: "🥛",
        works_item_title_3: "Warm Milk",
        works_item_desc_3: "Classic bedtime drink. Dissolves in 5 seconds",
        
        science_heading: "Sperm Takes <span class='gold'>74 Days</span>",
        science_tl_title_1: "Foundations Laid",
        science_tl_desc_1: "The herbs start working on cortisol and hormonal balance. Antioxidant activity goes up, reducing oxidative stress on sperm that is already present.",
        science_tl_title_2: "Sperm Actively Forming",
        science_tl_desc_2: "New sperm cells are forming in a better hormonal environment. Gokshura and Ashwagandha are actively supporting LH and testosterone levels throughout this window.",
        science_tl_title_3: "Mature Sperm, Measurable Results",
        science_tl_desc_3: "Sperm produced over the past six weeks are reaching maturity. Most users who do a follow-up semen analysis at this point see measurable improvement in count, motility or morphology.",


    
    },

    S_VMG_ASC_Grinder_UGC: {
        hero_h1: "Train harder.<br><span>Recover faster.</span>",
        hero_subhead:
            "Protein helps build muscle. Vitality Mix supports stamina, strength, recovery and daily training energy with 8 Ayurvedic extracts.",
        hero_badge: "Gym Edition · Extract-Based",
        hero_pour:"Into protein shake",
        hero_cta: "Add to Cart — Upgrade My Gym Routine →",
        works_heading: "Built for men who train.",
        works_subheading: "Not a supplement. A performance stack.",
        works_box_heading: "🏋️ Mix it into your shake. Train harder.",
        works_note: "<p><strong>Gym tip:</strong> Use one sachet after workout with your protein shake. Protein supports muscle. Ayurvedic extracts support stamina, recovery and training consistency.</p>",
        works_item_icon_1: "🏋️",
        works_item_title_1: "More from every session",
        works_item_desc_1: "Kaunch + Ashwagandha prime your body for output. Your effort hits harder when your foundation is right.",

        works_item_icon_2: "⚡",
        works_item_title_2: "Energy without the crash",
        works_item_desc_2: "No caffeine. No jitters. Sustained energy from herbal adaptogens that work with your body — not against it.",

        works_item_icon_3: "💪",
        works_item_title_3: "Recover while you sleep",
        works_item_desc_3: "Vidarikand + Safed Musali support deep recovery. You grow when you rest — this makes that rest count.",


        science_heading: "Week by week. <span class='gold'>Real changes.</span>",
        science_tl_title_1: "Energy unlocks",
        science_tl_desc_1: "Afternoon slumps gone. You are training with more focus and finishing stronger.",
        science_tl_title_2: "The stack clicks",
        science_tl_desc_2: "Recovery speeds up. Gym numbers move. Your coach or training partner notices before you do.",
        science_tl_title_3: "This is the new baseline",
        science_tl_desc_3: "Consistent output. Better sleep. Consistent output at the gym and through the day. This is what the protocol does.",

        faq_heading: "Gym Questions <span class='gold'>Answered</span>",
        faq_intro: "For men who train, lift and want better output from the same routine.",

        faq_tag_1: "GYM PERFORMANCE",
        faq_question_1: "Can I mix it with my protein shake?",
        faq_answer_1: "<p>Yes — thats how most gym-goers take it. It dissolves completely, adds chocolate flavour, and the herbs work alongside your protein for better recovery.</p>",

        faq_tag_2: "100% SAFE",
        faq_question_2: "Is this safe to take daily?",
        faq_answer_2: "<p>100% safe. All herbal extracts. No steroids, no chemicals. Made in an FDA approved, GMP certified facility. Lab tested for heavy metals and contaminants.</p>",

        faq_tag_3: "ENERGY",
        faq_question_3: "When will I feel the difference?",
        faq_answer_3: "<p>Most men feel an energy shift by week 1–2. Gym performance improves by week 3–4. Full protocol effect at 60–90 days.</p>",

        faq_tag_4: "NO CAFFEINE",
        faq_question_4: "Does it have caffeine or stimulants?",
        faq_answer_4: "<p>No caffeine, no stimulants. The energy boost comes from adaptogenic herbs that regulate your body's own systems — not a temporary spike.</p>",

        final_cta_heading: "Your Gym Routine Deserves<br>More Than Protein",
        final_cta_desc: "Add 8 Ayurvedic extracts to support stamina, recovery, strength and daily performance. One sachet. Five seconds.",

    },

    S_VMG_ASC_Climber5sec_V: {
      hero_h1: "Your ambition is at 100%.<br><span>Your body needs to catch up.</span>",
      hero_subhead: "Add Ashwagandha, Kaunch, Gokshur, Safed Musali and more into your existing shake/milk/water. Tear, pour, drink.",
      hero_badge: "Protein Shake Upgrade",
       hero_pour:"Into protein shake/milk/water",
      hero_cta: "Add to Cart — Upgrade My Protein →",
      works_heading: "For men who can't afford to slow down.",
      works_subheading: "Energy. Focus. Stamina. All day.",
      works_box_heading: "🥤 Add one sachet to your daily shake/milk/water.",
      works_note: "<p><strong>Protein tip:</strong> Mix one sachet directly into your whey, plant protein or regular shake. No extra routine. No bitter churna. Just tear, pour, drink.</p>",
      works_item_icon_1: "🧠",
        works_item_title_1: "Sharper focus at work",
        works_item_desc_1: "Ashwagandha is one of the most studied adaptogens for stress response. It helps your body handle pressure more efficiently — so you think clearer when it matters most.",

        works_item_icon_2: "⚡",
        works_item_title_2: "No more 3pm crash",
        works_item_desc_2: "Adaptogenic herbs stabilise your energy through the day. No spike, no crash. Just steady output from 9am to 9pm.",

        works_item_icon_3: "🔥",
        works_item_title_3: "Drive in every room",
        works_item_desc_3: "Kounch supports sustained energy and focus — so you're performing at the office, at the gym, and at home.",
      
      
        science_heading: "Week by week. <span class='gold'>The shift you'll notice.</span>",
        science_tl_title_1: "The fog lifts",
        science_tl_desc_1: "Afternoon crashes reduce. You're sharper in meetings. Sleep is deeper. The baseline improves.",
        science_tl_title_2: "Output increases",
        science_tl_desc_2: "You're doing more with the same hours. Energy holds through the evening. You're present again.",
        science_tl_title_3: "The full protocol",
        science_tl_desc_3: "Sustained performance at work, at the gym, at home. The 82% who reorder — this is what they found.",

        faq_heading: "Quick <span class='gold'>answers.</span>",
        faq_intro: "For men who already take protein and want to make the routine more complete.",

        faq_tag_1: "Ashwagandha",
        faq_question_1: "Will this help with work stress and burnout?",
        faq_answer_1: "<p>Yes. Ashwagandha is one of the most studied adaptogens for cortisol regulation. It doesn't sedate — it helps your body handle pressure more efficiently.</p>",

        faq_tag_2: "100% safe",
        faq_question_2: "Is this safe to take long term?",
        faq_answer_2: "<p>100% safe for daily use. All herbal extracts, no steroids, no chemicals. FDA approved facility, GMP certified, lab tested.</p>",

        faq_tag_3: "No caffeine",
        faq_question_3: "Will it keep me up at night?",
        faq_answer_3: "<p>No caffeine, no stimulants. Most men report better sleep quality — not worse. The adaptogens help your nervous system wind down properly.</p>",

        faq_tag_4: "5 seconds",
        faq_question_4: "How do I take it?",
        faq_answer_4: "<p>Tear the sachet, pour into warm milk or a shake, stir for 5 seconds. That's it. One sachet a day. Chocolate flavour. Zero sugar.</p>",

        
        final_cta_heading: "Your output<br/> deserves better fuel.",
        final_cta_desc: "One sachet. Five seconds. Start today.",

    },

    S_VMG_ASC_Prime33_V: {
      hero_h1: "You're not slowing down.<br><span>You just need better fuel.</span>",
      hero_subhead:
        "Vitality Mix supports post-workout recovery, daily energy and strength through 8 extract-based Ayurvedic herbs.",
      hero_badge: "Recovery + Strength Support",
       hero_pour:"Into protein shake/milk/water",
      hero_cta: "Add to Cart — ",
      works_heading: "For men who still have a lot to give.",
       works_subheading: "Restore what stress and time have quietly taken.",
        works_box_heading: "💪 Train. Recover. Repeat.",
        works_note: "<p><strong>Recovery tip:</strong> Take it consistently after training or in the evening. The goal is not one-day stimulation — it is daily recovery, stamina and energy support.</p>",
       
        works_item_icon_1: "💪",
        works_item_title_1: "Restore energy and strength",
        works_item_desc_1: "Supports recovery after strength training and heavy sessions",

        works_item_icon_2: "⚡",
        works_item_title_2: "Consistent energy all day",
        works_item_desc_2: "Adaptogenic herbs stabilise your output. You stop relying on coffee to get through the afternoon.",

        works_item_icon_3: "💤",
        works_item_title_3: "Sleep that actually repairs",
        works_item_desc_3: "Vidarikand and Ashwagandha support deep restorative sleep — so you wake up recovered, not just rested.",

        science_heading: "Week by week. <span class='gold'>The shift you'll notice. </span>",
        science_tl_title_1: "Energy returns",
        science_tl_desc_1: "The afternoon dip disappears. Sleep is deeper. You wake up with more in the tank.",
        science_tl_title_2: "Strength returns",
        science_tl_desc_2: "Gym numbers move. Recovery is faster. You feel like yourself again.",
        science_tl_title_3: "The new normal",
        science_tl_desc_3: "Energy and strength restored. At 33 you can feel like you did at 27. This is what the protocol does.",

        faq_heading: "Questions <span class='gold'>Answered</span>",
        faq_intro: "Quick answers.",

        faq_tag_1: "Especially",
        faq_question_1: "Is this right for men in their 30s?",
        faq_answer_1: "<p>Especially. The herbs in this formula — Kounch, Gokshur, Ashwagandha — are specifically chosen to support the energy and recovery needs of men in their 30s.</p>",

        faq_tag_2: "100% safe",
        faq_question_2: "Is this safe to take long term?",
        faq_answer_2: "<p>100% safe for daily use. All herbal extracts, no steroids, no chemicals. FDA approved facility, GMP certified, lab tested.</p>",

        faq_tag_3: "No caffeine",
        faq_question_3: "Will it keep me up at night?",
        faq_answer_3: "<p>No caffeine, no stimulants. Most men report better sleep quality — not worse. The adaptogens help your nervous system wind down properly.</p>",

        faq_tag_4: "ROUTINE",
        faq_question_4: "How do I take it?",
        faq_answer_4: "<p>Tear the sachet, pour into warm milk or a shake, stir for 5 seconds. That's it. One sachet a day. Chocolate flavour. Zero sugar.</p>",

        final_cta_heading: "You're not 22.<br>You don't have to feel like it either.",
        final_cta_desc: "You're at your peak. This keeps you there.",
        },

    S_VMG_ASC_Reckoning41_V: {
      hero_h1: "Most men feel the shift at 38.<br><span>You don't have to accept it.</span>",
      hero_subhead:
        "Protein is only one part od maintaining your body. Vitality Mix supports stamina, endurance and male vitality with one daily sachet.",
      hero_badge: "Stamina Support Formula",
       hero_pour:"Into protein shake/milk/water",
      hero_cta: "Add to Cart — ",

      works_heading: "The decline is real. So is the reversal.",
    works_subheading: "Specific herbs. Exact doses. Clinical results.",
    works_box_heading: "⚡ Small sachet. Bigger daily support.",
    works_note: "<p><strong>Stamina tip:</strong> Use one sachet daily for 30–90 days. Stamina support works best when your routine is consistent.</p>",
    
    works_item_icon_1: "🔬",
    works_item_title_1: "Vitality support support that works",
    works_item_desc_1: "Gokshur and Kounch are standardised to exact potencies — so you actually get a dose strong enough to feel the difference.",

    works_item_icon_2: "📈",
    works_item_title_2: "Reverse the energy decline",
    works_item_desc_2: "Not a stimulant. Adaptogenic herbs that rebuild your body's own energy systems — the decline isn't permanent if you act now.",

    works_item_icon_3: "💪",
    works_item_title_3: "Strength and stamina restored",
    works_item_desc_3: "Semal Musali and Safed Musali help rebuild what years of stress and cortisol have slowly taken. The gym response improves.",
    
    
    science_heading: "Week by week.<span class='gold'> The shift you'll notice.</span>",
    science_tl_title_1: "The first signs",
    science_tl_desc_1: "Noticeably better sleep. Morning energy. The constant fatigue starts to lift — most men feel this by day 10.",
    science_tl_title_2: "The shift is real",
    science_tl_desc_2: "Strength improving. Stamina returning. You're not compensating anymore — you're performing.",
    science_tl_title_3: "The protocol result",
    science_tl_desc_3: "The men who complete 90 days don't go back. Energy, stamina, strength — all elevated. This is the new baseline.",


    faq_heading: "<span class='gold'>FAQs</span>",
    faq_intro: "Quick answers.",

    faq_tag_1: "T-SUPPORT",
    faq_question_1: "Is this proven to work for men over 38?",
    faq_answer_1: "<p>Yes. The herbs are standardised to exact potencies — this is what separates it from churna that didn't work. Gokshur, Kounch, and Ashwagandha are all well-studied Ayurvedic herbs for men's energy, strength, and recovery.</p>",

    faq_tag_2: "100% safe",
        faq_question_2: "Is this safe to take long term?",
        faq_answer_2: "<p>100% safe for daily use. All herbal extracts, no steroids, no chemicals. FDA approved facility, GMP certified, lab tested.</p>",

        faq_tag_3: "No caffeine",
        faq_question_3: "Will it keep me up at night?",
        faq_answer_3: "<p>No caffeine, no stimulants. Most men report better sleep quality — not worse. The adaptogens help your nervous system wind down properly.</p>",

        faq_tag_4: "ROUTINE",
        faq_question_4: "How do I take it?",
        faq_answer_4: "<p>Tear the sachet, pour into warm milk or a shake, stir for 5 seconds. That's it. One sachet a day. Chocolate flavour. Zero sugar.</p>",

    final_cta_heading: "The shift at 38<br>doesn't have to be permanent.",
    final_cta_desc: "Most men accept the decline. You don't have to.",

    },

    S_VMG_ASC_ReinvTried_V: {
      hero_h1: "50 feels different<br><span>when you start at 43.</span>",
      hero_subhead:
        "Kaunch, Ashwagandha, Gokshur, Safed Musali and 4 more Ayurvedic extracts in one daily chocolate sachet.",
      hero_badge: "New Formula · Extract-Based",
       hero_pour:"Into protein shake/milk/water",
      hero_cta: "Add to Cart — Start My Protocol →",

    works_heading: "It's not too late. Not even close.",
    works_subheading: "The reason other things didn't work — and why this will.",
    works_box_heading: "🌿 Support strength from the inside.",
    works_note: "<p><strong>Protocol tip:</strong> Kaunch, Ashwagandha, Gokshur and Safed Musali work best with consistency. One sachet daily is the routine.</p>",
    works_item_icon_1: "🔬",
    works_item_title_1: "Why extracts work when churna didn't",
    works_item_desc_1: "Raw powder has wildly varying potency. Standardised extracts deliver exact active compounds every time. Most men who 'tried Ayurveda' never got a clinical dose.",

    works_item_icon_2: "🌱",
    works_item_title_2: "Your body hasn't stopped responding",
    works_item_desc_2: "Most men who don't see results from supplements were simply under-dosed. Standardised extracts deliver what your body actually needs - the difference is real.",

    works_item_icon_3: "⏳",
    works_item_title_3: "The long game wins",
    works_item_desc_3: "90 days is where the real result lives. Men who complete the full protocol report the most significant changes. This is a rebuild, not a quick fix.",
    
    science_heading: "Week by week. <span class='gold'>The shift you'll notice.</span>",
    science_tl_title_1: "Something shifts",
    science_tl_desc_1: "Sleep deepens. Morning is different. The fatigue that became your normal starts to lift. Men over 43 often feel this faster than they expect.",
    science_tl_title_2: "The rebuild begins",
    science_tl_desc_2: "Energy is consistent. Gym response improves. Stamina returns. You remember what this felt like.",
    science_tl_title_3: "50 will be different",
    science_tl_desc_3: "The men who reach 90 days say the same thing: 'I wish I started earlier.' Start now and 50 will be a different story.",

    faq_heading: "<span class='gold'>FAQs</span>",
    faq_intro: "Quick answers.",

    faq_tag_1: "Extracts",
    faq_question_1: "I've tried Ayurvedic supplements before and nothing worked. Why will this?",
    faq_answer_1: "<p>Because you were probably taking raw powder, not standardised extracts. The active compounds vary up to 8× in raw herbs. This product has exact mg of verified-potency extracts — the dose your body actually needs.</p>",

        faq_tag_2: "100% safe",
        faq_question_2: "Is this safe to take long term?",
        faq_answer_2: "<p>100% safe for daily use. All herbal extracts, no steroids, no chemicals. FDA approved facility, GMP certified, lab tested.</p>",

        faq_tag_3: "No caffeine",
        faq_question_3: "Will it keep me up at night?",
        faq_answer_3: "<p>No caffeine, no stimulants. Most men report better sleep quality — not worse. The adaptogens help your nervous system wind down properly.</p>",

        faq_tag_4: "ROUTINE",
        faq_question_4: "How do I take it?",
        faq_answer_4: "<p>Tear the sachet, pour into warm milk or a shake, stir for 5 seconds. That's it. One sachet a day. Chocolate flavour. Zero sugar.</p>",

    final_cta_heading: "Start at 43.<br>Change what 50 feels like.",
    final_cta_desc: "You have more years ahead than behind. Spend them well.",

    },

    office: {
      hero_h1: "Still tired after protein?<br><span>Your energy system needs more.</span>",
      hero_subhead:
        "Vitality Mix supports daily energy, stress resilience and strength for men who train, work and still need to perform.",
      hero_badge: "Daily Energy + Gym Support",
      hero_cta: "Add to Cart — Support My Daily Energy →",
      works_heading: "Works with your busy day.",
    works_subheading: "Gym, office, travel, late nights — keep the routine simple.",
    works_box_heading: "☕ Replace the crash with a better ritual.",
    works_note: "<p><strong>Daily tip:</strong> Use it with your morning shake or evening milk. It is made for men who need energy for work and strength for training.</p>",
    works_item_icon_1: "💼",
    works_item_title_1: "Workday Energy",
    works_item_desc_1: "Supports energy for long workdays and late gym sessions",

    works_item_icon_2: "🥤",
    works_item_title_2: "Morning Shake",
    works_item_desc_2: "Add one sachet to your morning protein or milk",

    works_item_icon_3: "🏋️",
    works_item_title_3: "After Office Gym",
    works_item_desc_3: "Helps support stamina when training after a full workday",
    science_heading: "Energy Support Is <span class='gold'>Not Instant Coffee</span>",
    science_tl_title_1: "Daily Rhythm Starts",
    science_tl_desc_1: "Use it with your morning shake or evening milk. The goal is a simple energy-support habit.",
    science_tl_title_2: "Less Afternoon Drag",
    science_tl_desc_2: "With regular use, many men feel better energy stability between work, gym and daily responsibilities.",
    science_tl_title_3: "Performance Routine Builds",
    science_tl_desc_3: "By weeks 7–8, the routine supports both daily energy and training consistency.",
    faq_heading: "Testosterone Support <span class='gold'>FAQs</span>",
    faq_intro: "Clear answers for men looking for natural Ayurvedic support.",

    faq_tag_1: "T-SUPPORT",
    faq_question_1: "Does Vitality Mix contain testosterone?",
    faq_answer_1: "<p>No. It does not contain testosterone or synthetic hormones. It uses Ayurvedic herbs traditionally used to support male vitality and strength.</p>",

    faq_tag_2: "HERBS",
    faq_question_2: "Which herbs support male vitality?",
    faq_answer_2: "<p>The formula includes Kaunch, Ashwagandha, Gokshur, Safed Musali, Akarkara, Semal Musali, Kali Musali and Vidarikand.</p>",

    faq_tag_3: "DEPENDENCY",
    faq_question_3: "Will my body become dependent on it?",
    faq_answer_3: "<p>No. It is not a hormone replacement product. It is a herbal supplement designed for natural support.</p>",

    faq_tag_4: "AGE",
    faq_question_4: "Can young men use it?",
    faq_answer_4: "<p>It is intended for adult men. Men under 18 should not use it. If you have a medical condition, consult your doctor first.</p>",

    faq_tag_5: "RESULTS",
    faq_question_5: "How long does hormonal support take?",
    faq_answer_5: "<p>Natural support takes consistency. Most users should think in terms of 30–90 days, not overnight stimulation.</p>",

    final_cta_heading: "Work Hard. Train Hard.<br>Stay Powered.",
    final_cta_desc: "A simple daily sachet for men balancing office pressure, gym goals and everyday energy.",

    },

    ayurveda: {
      hero_h1: "Ayurveda just made<br><span>your protein smarter.</span>",
      hero_subhead:
        "8 clinically-dosed Ayurvedic extracts in a 4g chocolate sachet. Add it to your shake in five seconds.",
      hero_badge: "Ayurveda Meets Protein",
      hero_cta: "Add to Cart — Try The Ayurvedic Upgrade →",
      works_heading: "Ayurveda that fits modern routines.",
    works_subheading: "No churna mess. No bitter taste. Just one chocolate sachet.",
    works_box_heading: "🌿 Traditional herbs. Modern sachet.",
    works_note: "<p><strong>Ayurveda tip:</strong> Vitality Mix gives you 8 Ayurvedic extracts in a simple daily format — easy to mix, easy to carry, easy to stay consistent.</p>",
    works_item_icon_1: "🌿",
    works_item_title_1: "Ayurvedic Extracts",
    works_item_desc_1: "8 herbs in a simple modern sachet format",

    works_item_icon_2: "🥤",
    works_item_title_2: "No Churna Mess",
    works_item_desc_2: "Mixes into your shake without measuring or bitter taste",

    works_item_icon_3: "📦",
    works_item_title_3: "Pre-Dosed Sachets",
    works_item_desc_3: "Easy to carry, easy to use, easy to stay consistent",
    science_heading: "Ayurveda Works Best With <span class='gold'>Consistency</span>",
    science_tl_title_1: "Simple Daily Start",
    science_tl_desc_1: "One sachet makes Ayurveda easy to start — no bitter powder, no measuring, no complicated routine.",
    science_tl_title_2: "Herbal Support Builds",
    science_tl_desc_2: "The extracts support strength, stamina, recovery and vitality as the daily routine continues.",
    science_tl_title_3: "Modern Protocol Effect",
    science_tl_desc_3: "By weeks 7–8, the benefit of a simple, consistent Ayurvedic protocol becomes easier to feel.",


    faq_heading: "Testosterone Support <span class='gold'>FAQs</span>",
    faq_intro: "Clear answers for men looking for natural Ayurvedic support.",

    faq_tag_1: "T-SUPPORT",
    faq_question_1: "Does Vitality Mix contain testosterone?",
    faq_answer_1: "<p>No. It does not contain testosterone or synthetic hormones. It uses Ayurvedic herbs traditionally used to support male vitality and strength.</p>",

    faq_tag_2: "HERBS",
    faq_question_2: "Which herbs support male vitality?",
    faq_answer_2: "<p>The formula includes Kaunch, Ashwagandha, Gokshur, Safed Musali, Akarkara, Semal Musali, Kali Musali and Vidarikand.</p>",

    faq_tag_3: "DEPENDENCY",
    faq_question_3: "Will my body become dependent on it?",
    faq_answer_3: "<p>No. It is not a hormone replacement product. It is a herbal supplement designed for natural support.</p>",

    faq_tag_4: "AGE",
    faq_question_4: "Can young men use it?",
    faq_answer_4: "<p>It is intended for adult men. Men under 18 should not use it. If you have a medical condition, consult your doctor first.</p>",

    faq_tag_5: "RESULTS",
    faq_question_5: "How long does hormonal support take?",
    faq_answer_5: "<p>Natural support takes consistency. Most users should think in terms of 30–90 days, not overnight stimulation.</p>",

    final_cta_heading: "Ayurveda Made Simple<br>For Modern Men",
    final_cta_desc: "No churna mess. No bitter taste. Just one chocolate sachet with 8 Ayurvedic extracts.",

    }
  };

  function normalise(value) {
    return String(value || '')
  }

  function getAngleFromUrl() {
    var params = new URLSearchParams(window.location.search);

    for (var i = 0; i < CONFIG.acceptedParams.length; i++) {
      var key = CONFIG.acceptedParams[i];
      var value = normalise(params.get(key));

      if (value && CONTENT[value]) {
        return value;
      }
    }

    return '';
  }

  function saveAngle(angle) {
    try {
      localStorage.setItem(CONFIG.storageKey, angle);
      localStorage.setItem(CONFIG.storageTimeKey, String(Date.now()));
    } catch (e) {}
  }

  function getSavedAngle() {
    try {
      var savedAngle = localStorage.getItem(CONFIG.storageKey);
      var savedTime = Number(localStorage.getItem(CONFIG.storageTimeKey) || 0);

      if (!savedAngle || !savedTime || !CONTENT[savedAngle]) return '';

      var maxAge = CONFIG.expiryDays * 24 * 60 * 60 * 1000;
      var age = Date.now() - savedTime;

      if (age > maxAge) {
        localStorage.removeItem(CONFIG.storageKey);
        localStorage.removeItem(CONFIG.storageTimeKey);
        return '';
      }

      return savedAngle;
    } catch (e) {
      return '';
    }
  }

  function getActiveAngle() {
    var urlAngle = getAngleFromUrl();

    if (urlAngle) {
      saveAngle(urlAngle);
      return urlAngle;
    }

    return getSavedAngle() || 'default';
  }

  function setHtml(el, value) {
    if (!el || typeof value === 'undefined' || value === null) return;
    el.innerHTML = value;
  }

  function setText(el, value) {
    if (!el || typeof value === 'undefined' || value === null) return;
    el.textContent = value;
  }

  function applyContent(root, data, angle) {
    root.querySelectorAll('[data-ayam-utm-key]').forEach(function (el) {
      var key = el.getAttribute('data-ayam-utm-key');
      var mode = el.getAttribute('data-ayam-utm-mode') || 'html';

      var value = data[key];

      if (typeof value === 'undefined') {
        value = CONTENT.default[key];
      }

      if (typeof value === 'undefined') return;

      if (mode === 'text') {
        setText(el, value);
      } else {
        setHtml(el, value);
      }

      el.setAttribute('data-ayam-active-angle', angle);
    });
  }

  function init() {
    var angle = getActiveAngle();
    var data = CONTENT[angle] || CONTENT.default;

    document.documentElement.setAttribute('data-ayam-utm-angle', angle);

    document.querySelectorAll('[data-ayam-utm-scope]').forEach(function (root) {
      applyContent(root, data, angle);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();